<template>
	<div id="app">
		<div class="header">
			<div class="logo_img" @click="logoClick">
				<div style="display:flex; align-items: center; float:left; height: 60px;">
					<div class="header-logo"><img id="header-img" src="http://dgoss.91dageng.com.cn/png/PTE2qONt9QfdYFRF1103_组 1@3x.png" /></div>
				</div>
				<div style="display:flex; float:left; height: 60px;">
					<div class="header-important"><div class="company_name">大庚健康</div></div>
				</div>
			</div>
			<div id="menu_index">
				<!-- web端菜单导航 -->
				<el-menu
					v-if="seen"
					:default-active="activeIndex"
					class="el-menu-demo"
					menu-trigger="click"
					text-color="#333"
					style="height: 65px; border:0;"
					mode="horizontal"
					@select="handleSelect"
				>
					<el-menu-item index="1" class="header-title">首页</el-menu-item>
					<!-- <el-submenu index="2">
                        <template slot="title">产品与解决方案</template>
                        <el-menu-item index="2-1">产品微观</el-menu-item>
                        <el-menu-item index="2-2">生鲜果蔬</el-menu-item>
                        <el-menu-item index="2-3" disabled>服装品牌</el-menu-item>
                        <el-menu-item index="2-4" disabled>微商城小程序</el-menu-item>
                    </el-submenu> -->
					<el-menu-item index="3" class="header-title">关于我们</el-menu-item>
					<!-- <el-menu-item index="4" class="header-title">产品信息</el-menu-item> -->
					<el-menu-item index="5" class="header-title">行业资讯</el-menu-item>
					<el-menu-item index="6" class="header-title">联系我们</el-menu-item>
				</el-menu>
				<!-- 手机端菜单导航 v-bind:style="{backgroundColor:'#409EFF'}" -->
				<el-menu
					v-if="!seen"
					:default-active="activeIndex"
					class="el-menu-demo"
					menu-trigger="click"
					text-color="#333"
					style="height: 65px; border:0;"
					mode="horizontal"
					@select="handleSelect"
				>
					<el-submenu index="1" class="header-title mobile_menu">
						<template slot="title">
							{{ currentMenu }}
						</template>
						<el-menu-item index="1" class="header-title">首页</el-menu-item>
						<el-menu-item index="3" class="header-title">关于我们</el-menu-item>
						<!-- <el-menu-item index="4" class="header-title">产品信息</el-menu-item> -->
						<el-menu-item index="5" class="header-title">行业资讯</el-menu-item>
						<el-menu-item index="6" class="header-title">联系我们</el-menu-item>
					</el-submenu>
				</el-menu>
			</div>
			<!-- <div v-if="seen" style="float: right; display: flex;align-items: center; height: 100%;">
                <el-button type="text" style="margin-right: 20px;" class="header-title" @click="login">登录</el-button>
                <el-button type="primary" class="header-title" @click="register" round>注册</el-button>
            </div> -->
		</div>
		<div class="container" style="clear: both;"><router-view></router-view></div>
		<div style="width: 100%;background-image: url('http://dgoss.91dageng.com.cn/png/bRDta2pYGUVFacbL2231_组 31@3x.png');background-size: 100% 100%;">
			<div style="width: 90%;margin: 20px auto 0;">
				<div style="border-bottom: 1px solid #FFFFFF; display: flex;justify-content: center;text-align: center;">
					<el-row :gutter="20" style="padding: 20px 0; width: 52%;">
						<el-col :xs="24" :sm="6" class="footer_font"><span @click="handleSelect('3')">关于我们</span></el-col>
						<!-- <el-col :xs="24" :sm="6" class="footer_font"><span @click="handleSelect('4')">产品信息</span></el-col> -->
						<el-col :xs="24" :sm="6" class="footer_font"><span @click="handleSelect('5')">行业资讯</span></el-col>
						<el-col :xs="24" :sm="6" class="footer_font"><span @click="handleSelect('6')">联系我们</span></el-col>
						<!-- <p class="footer_font" style="padding: 0 20px;">产品信息</p>
							<p class="footer_font" style="padding-right:20px;">行业资讯</p>
							<p class="footer_font">联系我们</p> -->
					</el-row>
				</div>
				<el-row>
					<el-col :xs="24" style="display: flex;justify-content: center;padding: 16px;0 0 0">
						<div class="grid-content bg-purple" style="display: flex;flex-direction: row; align-items: center;margin: 10px 0;">
							<!-- <div><img id="header-img" src="http://dgoss.91dageng.com.cn/png/MhX69mJNCxRKVxAH2203_组 26@3x.png" /></div> -->
							<div style="color: #FFFFFF;">公司地址:上海普陀区祁连山南路2891弄科技楼105号213～214室</div>
						</div>
						<div class="grid-content bg-purple" style="display: flex;flex-direction: row; align-items: center;">
							<!-- <div><img id="header-img" src="http://dgoss.91dageng.com.cn/png/HJfTpLHYq9RfEzRg1013_组 28@3x.png" /></div> -->
							<div style="color: #FFFFFF; padding-left: 20px;">客服热线: 400-655-0669</div>
						</div>
					</el-col>
					<el-col :xs="24" style="display: flex;justify-content: center;">
						<div class="grid-content bg-purple-light" style="color: #FFFFFF;margin: 20px;">
							<a style="color:#fff" target="_blank" rel="noopener" href="https://beian.miit.gov.cn/#/Integrated/index">沪ICP备19044674号-1</a>
						</div>
						<div class="grid-content bg-purple-light" style="color: #FFFFFF;margin: 20px;">
							<a style="color:#fff" target="_blank" rel="noopener" href="https://dgoss.91dageng.com.cn/png/aVjdHwZRFboeOexf2310_WXTP_20260529120807.PNG">营业执照</a >
						</div>
						<div class="grid-content bg-purple-light" style="color: #FFFFFF;margin: 20px;">
							
							<a style="color:#fff" target="_blank" rel="noopener" href="https://dgoss.91dageng.com.cn/img/8e5651eef33a19566db0237ce9ada36a_.jpg">食品经营许可证</a>
							<!-- <el-button type="text" @click="dialogVisible = true" style="color: #FFFFFF;display: flex;margin-top: 10px;">食品经营许可证</el-button> -->
						</div>
						<div class="grid-content bg-purple-light" style="color: #FFFFFF;margin: 20px;">
							
							<a style="color:#fff" target="_blank" rel="noopener" href="https://dgoss.91dageng.com.cn/img/b37415cb54f8cbc1db9abfe9ae560c6a_.jpg">第二类医疗器械经营许可证</a>
						</div>
					</el-col>
					<el-col :xs="24" style="display: flex;justify-content: center;">
						<div class="grid-content bg-purple-light" style="color: #FFFFFF;margin: 20px;">
							
							<a style="color:#fff" target="_blank" rel="noopener" href="https://dgoss.91dageng.com.cn/jpeg/p6LxaBtebXN2rriJ3010_PMJT_29-5-2026_122234_.JPEG">互联网药品信息服务资格证书（沪）-非经营性-2023-0128</a>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
		<div id="back_to_top" ref="btn" @click="backTop" style="display: none;">
			<p style="font-size: 0.625em; font-weight: bold">TOP</p>
			<img src="../assets/other/launch.png" style="height: 45px;width: 35px" />
		</div>
		<!-- 弹框内容 -->
		<!-- <el-dialog
			title="提示"
			:visible.sync="dialogVisible"
			width="70%"
			:before-close="handleClose">
			<span>
				<img style="height: 100%;width: 100%;" src="http://dgoss.91dageng.com.cn/jpg/p0IaF3tHtVnbdgi00001_WXTP_20230830170026.JPG" >
			</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			</span>
		</el-dialog> -->
	</div>
</template>

<script>
export default {
	name: 'Layout',
	data() {
		return {
			dialogVisible: false,
			activeIndex: '1',
			company: {
				qrcode: require('../../static/other/公众号二维码.jpg')
			},
			scroll: '',
			timer: '',
			seen: true,
			currentMenu: '首页'
		};
	},
	methods: {
		// 关闭弹窗
		// handleClose(done) {
		//         this.$confirm('确认关闭？')
		//           .then(_ => {
		//             done();
		//           })
		//           .catch(_ => {});
		// },
		
		handleSelect(key) {
			this.activeIndex = key;
			sessionStorage.setItem('key', key);
			switch (key) {
				case '1':
					this.$router.push({ name: 'Index' });
					this.currentMenu = '首页';
					break;
				case '2-1':
					// window.location.hash = '#产品微观';
					break;
				case '2-2':
					this.$router.push({ name: 'Fruit' });
					break;
				case '2-3':
					this.$router.push({ name: 'Fashion' });
					break;
				case '3':
					this.$router.push({ name: 'company' });
					// window.location.hash = '#关于我们';
					this.currentMenu = '关于我们';
					break;
				// case '4':
				// 	this.$router.push({ name: 'product' });
				// 	// window.location.hash = '#产品信息';
				// 	this.currentMenu = '产品信息';
				// 	break;
				case '5':
					this.$router.push({ name: 'Information' });
					// window.location.hash = '#行业资讯';
					this.currentMenu = '行业资讯';
					break;
				case '6':
					this.$router.push({ name: 'Aboutus' });
					// window.location.hash = '#联系我们';
					this.currentMenu = '联系我们';
					break;
			}
		},
		handleSelectMobile(key) {
			switch (key) {
				case '1':
					this.$router.push({ name: 'Index' });
					this.currentMenu = '首页';
					break;
				case '2-1':
					this.$router.push({ name: 'Index' });
					// window.location.hash = '#产品微观';
					this.currentMenu = '首页';
					break;
				case '2-2':
					this.$router.push({ name: 'Fruit' });
					this.currentMenu = '生鲜果蔬';
					break;
				case '2-3':
					this.$router.push({ name: 'Fashion' });
					break;
				case '3':
					this.$router.push({ name: 'Index' });
					// window.location.hash = '#关于我们';
					this.currentMenu = '首页';
					break;
				case '4':
					this.$router.push({ name: 'Index' });
					// window.location.hash = '#合作伙伴';
					this.currentMenu = '首页';
					break;
				case '5':
					this.$router.push({ name: 'Index' });
					// window.location.hash = '#关于我们';
					this.currentMenu = '首页';
					break;
			}
		},
		handleScroll() {
			this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
			if (this.scroll > 600) {
				//判断滚动后高度超过400px,就显示
				this.$refs.btn.style.display = 'block';
			} else {
				this.$refs.btn.style.display = 'none';
			}
		},
		backTop() {
			//当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
			this.timer = setInterval(() => {
				let osTop = document.documentElement.scrollTop || document.body.scrollTop;
				let ispeed = Math.floor(-osTop / 5);
				document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
				if (osTop === 0) {
					clearInterval(this.timer);
				}
			}, 30);
		},
		login() {
			window.open('https://admin.fastice-tech.com/login');
		},
		register() {
			window.open('https://admin.fastice-tech.com/registe');
		},
		menuSeen() {
			// 屏幕尺寸
			let screenHeight = document.body.clientWidth;
			if (screenHeight > 415) {
				this.seen = true;
			} else {
				this.seen = false;
			}
		},
		logoClick() {
			this.handleSelect('1');
		}
	},
	mounted() {
			if (sessionStorage.getItem('key')) {
				this.activeIndex = sessionStorage.getItem('key');
				switch (this.activeIndex) {
					case '1':
						// this.$router.push({ name: 'Index' });
						this.currentMenu = '首页';
						break;
					case '2-1':
						// window.location.hash = '#产品微观';
						break;
					case '2-2':
						// this.$router.push({ name: 'Fruit' });
						break;
					case '2-3':
						// this.$router.push({ name: 'Fashion' });
						break;
					case '3':
						// this.$router.push({ name: 'company' });
						// window.location.hash = '#关于我们';
						this.currentMenu = '关于我们';
						break;
					// case '4':
						// this.$router.push({ name: 'product' });
						// window.location.hash = '#产品信息';
						// this.currentMenu = '产品信息';
						// break;
					case '5':
						// this.$router.push({ name: 'Information' });
						// window.location.hash = '#行业资讯';
						this.currentMenu = '行业资讯';
						break;
					case '6':
						// this.$router.push({ name: 'Aboutus' });
						// window.location.hash = '#联系我们';
						this.currentMenu = '联系我们';
						break;
				}
			}
		this.menuSeen();
		window.addEventListener('scroll', this.handleScroll);
	},
	watch: {
		$route() {
			if (sessionStorage.getItem('key')) {
				this.activeIndex = sessionStorage.getItem('key');
				switch (this.activeIndex) {
					case '1':
						// this.$router.push({ name: 'Index' });
						this.currentMenu = '首页';
						break;
					case '2-1':
						// window.location.hash = '#产品微观';
						break;
					case '2-2':
						// this.$router.push({ name: 'Fruit' });
						break;
					case '2-3':
						// this.$router.push({ name: 'Fashion' });
						break;
					case '3':
						// this.$router.push({ name: 'company' });
						// window.location.hash = '#关于我们';
						this.currentMenu = '关于我们';
						break;
					// case '4':
						// this.$router.push({ name: 'product' });
						// window.location.hash = '#产品信息';
						// this.currentMenu = '产品信息';
						// break;
					case '5':
						// this.$router.push({ name: 'Information' });
						// window.location.hash = '#行业资讯';
						this.currentMenu = '行业资讯';
						break;
					case '6':
						// this.$router.push({ name: 'Aboutus' });
						// window.location.hash = '#联系我们';
						this.currentMenu = '联系我们';
						break;
				}
			}
			// console.log('路由变化了')
			// console.log('当前页面路由：' + to);
			// console.log('上一个路由：' + from);
		}
	}
};
</script>

<style scoped>
.logo_img {
	float: left;
	/* width: 10%; */
	cursor: pointer;
	margin-right: 20px;
}
#back_to_top {
	position: fixed;
	bottom: 50px;
	right: 30px;
	cursor: pointer;
}
.header-title {
	font-size: 1em;
}
.company_name {
	font-weight: normal;
	font-size: 1em;
}
.footer_font {
	font-size: 1em;
	color: #ffffff;
}
#menu_index {
	float: left;
	/* width: 50%; */
	height: 100%;
}
.header {
	margin: auto;
	width: 90%;
	height: 65px;
	padding: 20px 0;
	/*background: #F56C6C;*/
}
@media screen and (max-device-width: 415px) {
	.logo_img {
		float: left;
		width: auto;
		cursor: pointer;
	}
	#back_to_top {
		position: fixed;
		bottom: 50px;
		right: 5px;
		cursor: pointer;
	}
	.footer_font {
		color: #ffffff;
		font-size: 0.875em;
	}
	#menu_index {
		float: right;
		width: auto;
		height: 100%;
	}
	.mobile_menu {
	}
}
#header-img {
	width: 50px;
	height: 50px;
	float: left;
	margin: auto;
}
.header-logo {
	height: 50px;
	width: 50px;
	align-self: center;
}
.header-important {
	float: left;
	margin-left: 6px;
	align-self: center;
}

.footer {
	display: flex;
	align-items: center;
	margin: 10px auto;
	width: 90%;
}
a {
	text-decoration: none;
}
a:visited {
	text-decoration: none;
}
a:hover {
	text-decoration: none;
}
a:active {
	text-decoration: none;
}
.container {
	min-height: 750px;
}
.el-menu--horizontal > .el-menu-item.is-active {
	border-bottom: none;
	color: white;
	background: #0775ff;
	font-weight: 700;
	border-radius: 10px;
	padding: auto 30px !important;
}
</style>
